import React from 'react';
import styled from 'styled-components';
import * as BuilderInfoUI from '../BuilderInfoUI';
import { appRoutes } from '../../../path';
import {
  EventConditionInfo,
  GoToDictionaryAction,
  InfoPopupHeader,
  InfoPopupSchema,
  ShowInReport,
} from '../components';
import { useCurrentUrl } from '../../../utils/routing';
import { IVirtualEventBuilderInfoProps } from '../types';
import {
  getUrlForDataSharing,
  SearchParamsDataSharingEnum,
} from '../../../utils/searchParamsDataSharing';
import { IEventConditionFieldsFragment } from '../../../utils/apollo/graphqlSchema';
import TableNames from '../../Builder/EntitySelection/details/TableNames';
import { extractTableNamesVirtualEvent } from '../../Builder/EntitySelection/utils';

const EventContainer = styled.div`
  margin-top: 8px;
`;

export default ({ virtualEvent, onExpand }: IVirtualEventBuilderInfoProps) => {
  const {
    description,
    eventsConditions,
    name,
    id,
    creator,
    comment,
    schema,
    createdAt,
    editor,
    editedAt,
  } = virtualEvent;

  const { isReportInUrl } = useCurrentUrl();

  const reportUrl = getUrlForDataSharing(appRoutes.report.query, {
    type: SearchParamsDataSharingEnum.VirtualEvent,
    virtualEventId: id,
    schemaId: schema.id,
  });

  const dictionaryUrl = getUrlForDataSharing(
    appRoutes.dictionary.virtualEvent,
    {
      type: SearchParamsDataSharingEnum.Dictionary,
      schemaId: schema.id,
      term: name,
    },
  );
  const tableNames = extractTableNamesVirtualEvent(virtualEvent);

  return (
    <>
      <InfoPopupHeader
        name={name}
        description={description}
        creator={creator}
        editor={editor}
        comment={comment}
        createdAt={createdAt}
        editedAt={editedAt}
        link={
          isReportInUrl && dictionaryUrl ? (
            <GoToDictionaryAction dictionaryUrl={dictionaryUrl} />
          ) : null
        }
      />
      <BuilderInfoUI.MainContent>
        <InfoPopupSchema name={schema.name} />
        <EventContainer>
          {eventsConditions.map((eventCondition, index) => {
            // Instead of EventConditionInfo there should be a custom component.
            // Because events array of eventCondition in this case
            // can't include Virtual events.
            return (
              <EventConditionInfo
                key={id + '_' + index}
                condition={eventCondition as IEventConditionFieldsFragment}
                label={'Event(s)'}
              />
            );
          })}
        </EventContainer>
      </BuilderInfoUI.MainContent>
      <BuilderInfoUI.FooterContainerLeft>
        {tableNames.length > 0 && (
          <TableNames tableNames={tableNames.join(', ')} />
        )}
      </BuilderInfoUI.FooterContainerLeft>
      {(onExpand || !isReportInUrl) && (
        <BuilderInfoUI.FooterContainer>
          {onExpand && (
            <BuilderInfoUI.PopupSecondaryButton
              type="button"
              onClick={onExpand}
              trackContext="virtual event"
              trackAction="expand"
              size="small"
            >
              Expand
            </BuilderInfoUI.PopupSecondaryButton>
          )}
          {!isReportInUrl && reportUrl && (
            <ShowInReport reportUrl={reportUrl} trackContext="virtual event" />
          )}
        </BuilderInfoUI.FooterContainer>
      )}
    </>
  );
};
